import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "./store";
import { MAIN_URL } from "./UserAPI";


export const getAppStatus= createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("app/getAppStatus", async (_, { rejectWithValue }) => {
  try {
    const { data } = await axios.get(`${MAIN_URL}/app_status`);
    console.log(data)
    return data as any;
  } catch (err: any) {
    console.log(err.message);
    return rejectWithValue(err.response.data.msg);
  }
});